// @flow

const INITIAL_STATE = {
    domainId: null,
    report: null,
    loading: false,
    starting: false,
    error: null,
};

const Diagnostics = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'DIAGNOSTICS_LATEST_LOAD':
            return { ...state, domainId: action.payload.domainId, loading: true, error: null };
        case 'DIAGNOSTICS_START':
            return { ...state, domainId: action.payload.domainId, starting: true, error: null };
        case 'DIAGNOSTICS_STARTED':
        case 'DIAGNOSTICS_LOADED':
            if (state.domainId !== null && state.domainId !== action.payload.domainId) return state;
            return {
                ...state,
                domainId: action.payload.domainId,
                report: action.payload.report,
                loading: false,
                starting: false,
                error: null,
            };
        case 'DIAGNOSTICS_LATEST_MISSING':
            if (state.domainId !== null && state.domainId !== action.payload.domainId) return state;
            return { ...state, domainId: action.payload.domainId, report: null, loading: false, error: null };
        case 'DIAGNOSTICS_FAILED':
            if (state.domainId !== null && state.domainId !== action.payload.domainId) return state;
            return { ...state, domainId: action.payload.domainId, loading: false, starting: false, error: action.payload.error };
        case 'DIAGNOSTICS_STOP':
            return state;
        default:
            return state;
    }
};

export default Diagnostics;
